import { useEffect, useState } from 'react';

import { color } from 'asserts/styles/colors';
import FAQ from 'components/customer/FAQ';
import Notice from 'components/customer/Notice';
import Reference from 'components/customer/Reference';
import styled from 'styled-components';
import { Tabs } from 'antd';

import { ReactComponent as IconAttachMent } from 'asserts/icons/ic_attachment_lined.svg';
import { ReactComponent as IconMessage } from 'asserts/icons/ic_message_text_lined.svg';
import { ReactComponent as IconMegaphone } from 'asserts/icons/ic_megaphone_lined.svg';
import { useQuery } from '@tanstack/react-query';
import { QueryKeys, restfetcher } from 'queryClient';
import ReferenceSkeleton from 'components/skeleton/ReferenceSkeleton';
import FAQSkeleton from 'components/skeleton/FAQSkeleton';
import NoticeSkeleton from 'components/skeleton/NoticeSkeleton';
import { useLocation } from 'react-router-dom';

const CustomerCenter = () => {
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const activeTabKeyFromParam = urlParams.get('tab');

  const [activeTabKey, setActiveTabKey] = useState(activeTabKeyFromParam || '2');

  const boardlistApi = useQuery({
    queryKey: [QueryKeys.SALESTYPE, Number(activeTabKey)],
    queryFn: () =>
      restfetcher({
        method: 'POST',
        path: 'biz/board/menu/find',
        params: {
          boardtype: Number(activeTabKey)
        }
      })
  });

  const { data: boardData } = boardlistApi;

  useEffect(() => {
    boardlistApi.refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTabKey]);

  const tabDatas = [
    {
      key: '2',
      label: '교육 자료실',
      children:
        boardlistApi.status === 'success' ? (
          <Reference boardData={boardData.data} />
        ) : (
          <ReferenceSkeleton />
        )
    },
    {
      key: '3',
      label: 'FAQ',
      children:
        boardlistApi.status === 'success' ? (
          <FAQ activeTabKey={activeTabKey} boardData={boardData.data} />
        ) : (
          <FAQSkeleton />
        )
    },
    {
      key: '4',
      label: '공지사항',
      children:
        boardlistApi.status === 'success' ? (
          <Notice boardData={boardData.data} />
        ) : (
          <NoticeSkeleton />
        )
    }
  ];

  const getIconByActiveTabKey = (activeTabKey: string) => {
    switch (activeTabKey) {
      case '2':
        return <IconAttachMent />;
      case '3':
        return <IconMessage />;
      case '4':
        return <IconMegaphone />;
      default:
        return null;
    }
  };

  return (
    <Wrapper>
      <InnerWraper>
        <IconWrapper>{getIconByActiveTabKey(activeTabKey)}</IconWrapper>
        <Tabs
          destroyInactiveTabPane={true}
          onChange={(activeTabKey) => {
            setActiveTabKey(activeTabKey);
          }}
          activeKey={activeTabKey}
          items={tabDatas.map((tab) => ({
            key: tab.key,
            label: tab.label,
            children: tab.children
          }))}
        />
      </InnerWraper>
    </Wrapper>
  );
};

export default CustomerCenter;

const Wrapper = styled.div`
  width: 1440px;
  margin: 128px auto 0;
  color: ${color.navyLight};
`;

const IconWrapper = styled.div`
  position: absolute;
  right: 0;
  top: -65px;
`;

const InnerWraper = styled.div`
  position: relative;
  width: 890px;
  margin: 0 auto;
  top: 112px;

  & .ant-tabs-tab.ant-tabs-tab-active a,
  & a:active {
    color: ${color.black2};
    opacity: 1;
  }

  & .ant-tabs-tab a {
    color: ${color.black2};
    opacity: 0.4;
  }

  .ant-tabs-nav-list .ant-tabs-tab-btn {
    font-size: 20px;
    font-weight: 500;
  }

  .ant-tabs .ant-tabs-nav {
    margin: 0;
  }
`;
